import { cn } from '@/utils/styles';
import { getImageUrl } from '@utils/nutrition/getImageUrl';
import { useNavigate } from 'react-router-dom';

interface FoodCardProps {
  id: number;
  name: string;
  imageUrl: string;
  rank: 'Superfood' | 'Minimize' | 'Avoid';
}

export const FoodCard = ({ name, imageUrl, rank, id }: FoodCardProps) => {
  const navigate = useNavigate();

  const getRankColor = (rank: string) => {
    switch (rank) {
      case 'Superfood':
        return 'bg-green-500';
      case 'Minimize':
        return 'bg-yellow-500';
      case 'Avoid':
        return 'bg-red-500';
      default:
        return 'bg-gray-500';
    }
  };

  const handleFoodDetailsPageNavigation = (id: number) => {
    return navigate(`/nutrition/foods/${id}`);
  };

  return (
    <div
      className={cn(
        'px-1.5 py-1',
        'rounded-2xl',
        'bg-white',
        'flex items-center',
        'w-full',
        'cursor-pointer',
      )}
      onClick={() => handleFoodDetailsPageNavigation(id)}
    >
      <img
        src={getImageUrl(imageUrl)}
        alt={name}
        className="w-20 h-16 object-cover rounded-lg"
      />
      <div className="flex flex-col ml-4">
        <span className="typography-body text-primary mb-1">{name}</span>
        <div className="flex items-center gap-2">
          <div className={cn('w-2 h-2 rounded-full', getRankColor(rank))} />
          <span className="typography-caption1 text-primary/70">{rank}</span>
        </div>
      </div>
    </div>
  );
};
